import React from 'react';
import imgInvisible from './img_invisible.svg';

import './InvisibleProduct.css';
import {Link} from "react-router-dom";
import PropTypes from 'prop-types';
import {VISIBLE_TYPE} from '../../models/product';
import SimilarProductQueryWrapper from '../similarProductList/SimilarProductQueryWrapper';

// 비슷한 상품이 없을 때 대신 노출할 인기 매물 링크 (정적이라 모듈 스코프로 고정)
const popularProductsLink = (
    <Link to={'/collection/1'} className='InvisibleProduct-link'>
        {'후루츠 인기 매물 구경하기 >'}
    </Link>
);

/**
 * 숨김/차단 상품 UI (PRD-3423)
 * 딱딱한 안내 문구 대신 친근한 톤으로 안내하고, 비슷한 상품이 있으면 함께 노출한다.
 * 비슷한 상품이 없으면 인기 매물로 이동할 수 있는 링크를 대신 노출해 이탈을 줄인다.
 * @param visibleType 상품의 visible_type (차단/숨김 구분)
 * @param productId 비슷한 상품 조회에 사용할 상품 id
 * @returns {JSX.Element}
 * @constructor
 */
export default function InvisibleProduct({visibleType, productId}) {
    const isBlock = visibleType === VISIBLE_TYPE.BLOCK;

    return (
        <div className='InvisibleProduct container'>
            <div className='InvisibleProduct-message'>
                {isBlock ? (
                    <>
                        <img className='InvisibleProduct-img' src={imgInvisible} alt="차단된 상품입니다." />
                        <div className='InvisibleProduct-title'>이 멤버의 상품 정보를 확인할 수 없어요.</div>
                        <span className='InvisibleProduct-desc'>내가 상대를 차단했거나, 상대가 나를 차단했을 수 있어요.</span>
                    </>
                ) : (
                    <>
                        <div className='InvisibleProduct-emoji' aria-hidden="true">🫠</div>
                        <div className='InvisibleProduct-title'>앗, 이 상품은 숨겨졌어요</div>
                        <span className='InvisibleProduct-desc'>아쉽지만, 다른 상품도 둘러볼까요? 👇</span>
                    </>
                )}
            </div>
            {productId != null ? (
                <SimilarProductQueryWrapper
                    productId={String(productId)}
                    showMoreButton={false}
                    emptyFallback={popularProductsLink}
                />
            ) : popularProductsLink}
        </div>
    );
}

InvisibleProduct.propTypes = {
  visibleType: PropTypes.number,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
